module.exports = __webpack_public_path__ + "img/rebuild_yeh_pc3.67dc85d9.jpg";